import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "toggle"]

  connect() {
    this.mobile = window.matchMedia("(max-width: 720px)")
    this.syncLayout = () => this.reset()
    this.mobile.addEventListener("change", this.syncLayout)
    this.reset()
  }

  disconnect() {
    this.mobile.removeEventListener("change", this.syncLayout)
    this.unlockScroll()
  }

  reset() {
    this.close()
    this.dialogTarget.setAttribute("role", this.mobile.matches ? "dialog" : "presentation")
    if (!this.mobile.matches) this.dialogTarget.show()
  }

  open() {
    if (!this.mobile.matches || this.dialogTarget.open) return
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    this.dialogTarget.showModal()
    this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.unlockScroll()
  }

  closed() {
    // A queued close event may arrive after switching to the desktop layout.
    if (!this.dialogTarget.open) {
      this.toggleTarget.setAttribute("aria-expanded", "false")
      this.unlockScroll()
    }
  }

  cancel(event) {
    event.preventDefault()
    this.close()
  }

  backdrop(event) {
    if (this.mobile.matches && event.target === this.dialogTarget) this.close()
  }

  navigate(event) {
    if (this.mobile.matches && event.target.closest("a[href]")) this.close()
  }

  unlockScroll() {
    if (this.previousOverflow !== undefined) {
      document.body.style.overflow = this.previousOverflow
      this.previousOverflow = undefined
    }
  }
}
